import { isProductionBuildType } from '@/environment-detection'
import { datadogLogs, Datacenter } from '@datadog/browser-logs'
import { datadogRum } from '@datadog/browser-rum'

const datadogInit = () => {
  if (process.env.VUE_APP_DATADOG_TOKEN) {
    datadogLogs.init({
      clientToken: process.env.VUE_APP_DATADOG_TOKEN,
      datacenter: Datacenter.EU,
      forwardErrorsToLogs: true,
      sampleRate: 100
    })
  }
}

const datadogRumInit = () => {
  if (
    process.env.VUE_APP_DATADOG_RUM_CLIENT_TOKEN &&
    process.env.VUE_APP_DATADOG_RUM_APP_ID
  ) {
    datadogRum.init({
      applicationId: process.env.VUE_APP_DATADOG_RUM_APP_ID,
      clientToken: process.env.VUE_APP_DATADOG_RUM_CLIENT_TOKEN,
      datacenter: Datacenter.EU,
      sampleRate: 100
    })
  }
}

export const initDatadog = () => {
  if (isProductionBuildType) {
    datadogInit()
    datadogRumInit()
  }
}
